import { GetContract } from '@/services/fhir/contract/GetContract';
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useOrganizationContext } from './OrganizationContext';
import { Contract } from 'fhir/r5';

type ContractResource = Contract;

interface PostAttendanceContextValue {
  contractPostAttendance: ContractResource | null;
  refetchContract: () => Promise<void>;
}

interface PostAttendanceContextProviderProps {
  children: React.ReactNode;
}

export const PostAttendanceContext = createContext<PostAttendanceContextValue>({} as PostAttendanceContextValue);

export function PostAttendanceContextProvider({ children }: PostAttendanceContextProviderProps) {
  const { organization } = useOrganizationContext();
  const [contractPostAttendance, setContractPostAttendance] = useState<ContractResource | null>(null);

  const fetchContract = useCallback(async () => {
    try {
      if (!organization?.id) {
        console.warn("Nenhuma organização selecionada");
        setContractPostAttendance(null);
        return;
      }

      const contractData = await GetContract({
        organization: organization.id,
        count: 1,
        sort: true,
        status: "executed",
        identifier: "pos-atendimento",
      });
      
      if (contractData?.entry?.[0]?.resource) {
        const resource = contractData.entry?.[0]?.resource;
        setContractPostAttendance(resource);
      } else {
        setContractPostAttendance(null);
      }
    } catch (error) {
      console.error("Erro ao buscar contrato:", error);
      setContractPostAttendance(null);
    }
  }, [organization]);

  useEffect(() => {
    fetchContract();
  }, [fetchContract]);

  const contextValue: PostAttendanceContextValue = {
    contractPostAttendance,
    refetchContract: fetchContract,
  };

  return (
    <PostAttendanceContext.Provider value={contextValue}>
      {children}
    </PostAttendanceContext.Provider>
  );
}

export function usePostAttendanceContext() {
  return useContext(PostAttendanceContext);
} 